import { CONFIG_ACTION_TYPE } from './Type';

const DEFAULT_STATE = {
	ipAddress: { data: null, fetching: false, loaded: false, error: 'idle', status: 'idle' },
};

const INITIAL_STATE = {
	...DEFAULT_STATE,
};

const config = (state = INITIAL_STATE, action) => {
	if (action.type === CONFIG_ACTION_TYPE.IP_ADDRESS_FETCHING_START) {
		return {
			...state,
			ipAddress: { ...state.ipAddress, fetching: true },
		};
	} else if (action.type === CONFIG_ACTION_TYPE.IP_ADDRESS) {
		return {
			...state,
			ipAddress: {
				data: action.payload.data,
				status: action.payload.status,
				error: action.payload.error,
				fetching: false,
				loaded: true,
			},
		};
	}

	return state;
};

export default config;
